import { useNavigate } from "react-router-dom";
import { Button } from "../../components";
import React, { useEffect, useState } from "react";
import {
    delegatorDetailCardSections,
    validatorDetailCardSections,
} from "../../utils/constants";
import { addSpace, formatScientificNumber, handleDetailCardValues, isScientificNotation } from "../../utils/helper";

export default function ValidatorDetailCard({
    icon,
    title,
    tagText,
    setSelectedValidator,
    isDelegator,
    validatorData,
    delegatorData,
    rewards,
    setIsClaimModalOpen,
    setCurrentRewards,
    setSelectedData,
}) {
    const navigate = useNavigate();
    const [showClaimBtn, setShowClaimBtn] = useState(false);
    const [isToolTipOpen, setIsToolTipOpen] = useState(false);
    const [isValidatorToolTipOpen, setIsValidatorToolTipOpen] = useState(false);
    const [isValidatorRewardToolTipOpen, setIsValidatorRewardToolTipOpen] = useState(false);
    const [isDelegatorCommissionToolTipOpen, setIsDelegatorCommissionToolTipOpen] = useState(false);
    const total_unclaimed_commission = rewards?.total_unclaimed_comission ?? 0;
    const total_unclaimed_rewards = rewards?.total_unclaimed_rewards ?? 0;
    const totalRewardToClaim =
        total_unclaimed_commission + total_unclaimed_rewards;
    const totalRewards = total_unclaimed_rewards + rewards?.total_claimed_rewards;
    const totalCommission = rewards?.rewards?.total_unclaimed_comission + rewards?.rewards?.total_claimed_comission;
    const finalCommission = isNaN(totalCommission) ? validatorData?.validator_commission_earned : totalCommission
    const totalCommissionDelegatorCard = delegatorData ? delegatorData['validator_commission_earned'] : 0

    const [integerPartClaimedCommission, decimalPartClaimedCommission] = rewards?.total_claimed_comission.toString().split('.');
    const totalFormatedClaimedCommission = integerPartClaimedCommission + '.' + (decimalPartClaimedCommission ? decimalPartClaimedCommission.slice(0, 12) : '0'.repeat(12));

    const [integerPart, decimalPart] = rewards?.totalRewards.toString().split('.');
    const [integerPartCommission, decimalPartCommission] = totalCommission.toString().split('.');
// Ensure the decimal part is exactly 12 digits
    const formattedNumber = integerPart + '.' + (decimalPart ? decimalPart.slice(0, 12) : '0'.repeat(12));
    const formatedCommission = integerPartCommission + '.' + (decimalPartCommission ? decimalPartCommission.slice(0, 12) : '0'.repeat(12));

    const formattedRewards =
        rewards?.totalRewards > 1
            ? rewards?.totalRewards.toLocaleString("en-US")
            : isScientificNotation(rewards?.totalRewards)
                ? formatScientificNumber(rewards?.totalRewards, 18)
                : formattedNumber;

    useEffect(() => {
        if (
            rewards?.totalRewards > 0
        ) {
            setShowClaimBtn(true);
        }
    }, []);

    const handleDelegate = () => {
        const obj = {
            name: title,
            performance: delegatorData?.performance,
            commission: delegatorData?.commission,
            contract_address: delegatorData?.contract_address,
        };
        setSelectedValidator(obj);
        localStorage?.setItem("selectedValidator", JSON.stringify(obj));
        navigate("/my-account/unstake");
    };

    const handleMouseHover = (val) => {
        if (val === "Total Claimable Rewards") {
            setIsToolTipOpen(true);
        }
    };

    return (
        <div className='relative w-full flex flex-col justify-between gap-6 laptop:gap-[30px] rounded-[18px] border-[1.5px] border-[#FDFDFD]/[0.04] p-5 laptop:p-6 laptop:pb-5 bg-noise bg-cover bg-no-repeat bg-center bg-[#1A1A1A] overflow-hidden h-full group duration-500"'>
            <div className="flex items-center gap-4 laptop:gap-5">
                <div className="flex items-center justify-center p-[13px] w-[80px] h-[80px] rounded-2xl bg-[#010101]">
                    <img
                        src={icon}
                        alt=""
                        className=""
                    />
                </div>
                <div className="flex flex-col gap-3 laptop:gap-[14px]">
                    <h4 className="text-base laptop:text-[22px] font-medium leading-[18px] laptop:leading-6 text-primaryWhite">
                        {title}
                    </h4>
                    <div className="flex items-center justify-center gap-[10px] text-sm leading-none font-normal -tracking-04 px-[14px] py-3 text-green capitalize bg-green/[0.08] rounded-xl h-9 max-w-fit">
                        <span className="w-[6px] h-[6px] rounded-full bg-green"></span>
                        {tagText === "inactive"
                            ? tagText.slice(0, 2) + " " + tagText.slice(2)
                            : tagText}
                    </div>
                </div>
            </div>
            <div>
                {!isDelegator && (
                    <>
                        {Object.entries(validatorDetailCardSections).map(
                            ([key, value], index) => (
                                <React.Fragment key={key}>
                                    <h5 className="text-xsm laptop:text-sm font-normal leading-5 text-tagcolor mb-6 capitalize">
                                        {addSpace(key)}
                                    </h5>
                                    <ul className="flex flex-col gap-[18px] laptop:gap-[22px]">
                                        {Object.entries(value)?.map(
                                            ([key, val]) => (
                                                <li
                                                    key={key}
                                                    className="flex items-center justify-between text-sm laptop:text-base font-semibold leading-5 text-primaryWhite"
                                                >
                                                    <span className="font-normal opacity-50">
                                                        {val}
                                                    </span>
                                                    <div className="flex items-center">
                                                        <span className="pr-1">
                                                            {handleDetailCardValues(
                                                                key,
                                                                validatorData[key],
                                                                validatorData,
                                                                false
                                                            ) ?? "N/A"}
                                                        </span>
                                                        {key ===
                                                            "commission_earned" &&
                                                            !isDelegator && (
                                                                <div
                                                                    className="relative md:w-[18px] md:h-[18px] text-[#FFF5F566]/35 hover:text-white/80"
                                                                    id={
                                                                        validatorData?.id
                                                                    }
                                                                    onMouseEnter={() =>
                                                                        setIsValidatorToolTipOpen(
                                                                            true,
                                                                        )
                                                                    }
                                                                    onMouseLeave={() =>
                                                                        setIsValidatorToolTipOpen(
                                                                            false,
                                                                        )
                                                                    }
                                                                >
                                                                    {isValidatorToolTipOpen && (
                                                                        <div className="absolute right-[-6px] tooltip_custom bg-white text-[#06080C] rounded-[8px] py-[6px] px-4 w-max">
                                                                            <p className="text-[10px] lg:text-[14px] font-medium break-words">
                                                                                {validatorData?.validator_commission_earned >
                                                                                    1
                                                                                    ? validatorData?.validator_commission_earned?.toLocaleString(
                                                                                        "en-US",
                                                                                    )
                                                                                    : totalFormatedClaimedCommission}
                                                                            </p>
                                                                        </div>
                                                                    )}
                                                                    <svg
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                        width="22"
                                                                        height="22"
                                                                        viewBox="0 0 22 22"
                                                                        fill="none"
                                                                        style={{ width: "100%", height: "100%" }}
                                                                    >
                                                                        <path
                                                                            d="M10.9997 20.1667C16.0413 20.1667 20.1663 16.0417 20.1663 11C20.1663 5.95837 16.0413 1.83337 10.9997 1.83337C5.95801 1.83337 1.83301 5.95837 1.83301 11C1.83301 16.0417 5.95801 20.1667 10.9997 20.1667Z"
                                                                            stroke="currentColor"
                                                                            strokeWidth="1.5"
                                                                            strokeLinecap="round"
                                                                            strokeLinejoin="round"
                                                                        />
                                                                        <path
                                                                            d="M11 7.33337V11.9167"
                                                                            stroke="currentColor"
                                                                            strokeWidth="1.5"
                                                                            strokeLinecap="round"
                                                                            strokeLinejoin="round"
                                                                        />
                                                                        <path
                                                                            d="M10.9951 14.6666H11.0034"
                                                                            stroke="currentColor"
                                                                            strokeWidth="2"
                                                                            strokeLinecap="round"
                                                                            strokeLinejoin="round"
                                                                        />
                                                                    </svg>
                                                                </div>
                                                            )}
                                                        {key ===
                                                            "total_rewards" &&
                                                            !isDelegator && (
                                                                <div
                                                                    className="relative md:w-[18px] md:h-[18px] text-[#FFF5F566]/35 hover:text-white/80"
                                                                    id={
                                                                        validatorData?.id
                                                                    }
                                                                    onMouseEnter={() =>
                                                                        setIsValidatorRewardToolTipOpen(
                                                                            true,
                                                                        )
                                                                    }
                                                                    onMouseLeave={() =>
                                                                        setIsValidatorRewardToolTipOpen(
                                                                            false,
                                                                        )
                                                                    }
                                                                >
                                                                    {isValidatorRewardToolTipOpen && (
                                                                        <div className="absolute right-[-6px] tooltip_custom bg-white text-[#06080C] rounded-[8px] py-[6px] px-4 w-max">
                                                                            <p className="text-[10px] lg:text-[14px] font-medium break-words">
                                                                                {validatorData['total_rewards_generated'] >
                                                                                    1
                                                                                    ? validatorData['total_rewards_generated']?.toLocaleString(
                                                                                        "en-US",
                                                                                    )
                                                                                    : validatorData['total_rewards_generated']}
                                                                            </p>
                                                                        </div>
                                                                    )}
                                                                    <svg
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                        width="22"
                                                                        height="22"
                                                                        viewBox="0 0 22 22"
                                                                        fill="none"
                                                                        style={{ width: "100%", height: "100%" }}
                                                                    >
                                                                        <path
                                                                            d="M10.9997 20.1667C16.0413 20.1667 20.1663 16.0417 20.1663 11C20.1663 5.95837 16.0413 1.83337 10.9997 1.83337C5.95801 1.83337 1.83301 5.95837 1.83301 11C1.83301 16.0417 5.95801 20.1667 10.9997 20.1667Z"
                                                                            stroke="currentColor"
                                                                            strokeWidth="1.5"
                                                                            strokeLinecap="round"
                                                                            strokeLinejoin="round"
                                                                        />
                                                                        <path
                                                                            d="M11 7.33337V11.9167"
                                                                            stroke="currentColor"
                                                                            strokeWidth="1.5"
                                                                            strokeLinecap="round"
                                                                            strokeLinejoin="round"
                                                                        />
                                                                        <path
                                                                            d="M10.9951 14.6666H11.0034"
                                                                            stroke="currentColor"
                                                                            strokeWidth="2"
                                                                            strokeLinecap="round"
                                                                            strokeLinejoin="round"
                                                                        />
                                                                    </svg>
                                                                </div>
                                                            )}
                                                    </div>
                                                    {/* {handleDetailCardValues(
                                                        key,
                                                        validatorData[key],
                                                        validatorData,
                                                    ) ?? "N/A"} */}
                                                </li>
                                            ),
                                        )}
                                    </ul>
                                    {/* Add a <br /> tag if this is not the last item in the map */}
                                    {index !==
                                        Object.entries(
                                            validatorDetailCardSections,
                                        ).length -
                                        1 && <br />}
                                </React.Fragment>
                            ),
                        )}
                    </>
                )}
                {isDelegator && (
                    <>
                        {Object.entries(delegatorDetailCardSections).map(
                            ([key, value], index) => (
                                <React.Fragment key={key}>
                                    <h5 className="text-xsm laptop:text-sm font-normal leading-5 text-tagcolor mb-6 capitalize">
                                        {addSpace(key)}
                                    </h5>
                                    <ul className="flex flex-col gap-[18px] laptop:gap-[22px]">
                                        {Object.entries(value)?.map(
                                            ([key, val]) => (
                                                <li
                                                    key={key}
                                                    className="flex items-center justify-between text-sm laptop:text-base font-semibold leading-5 text-primaryWhite"
                                                >
                                                    <span className="font-normal opacity-50">
                                                        {val}
                                                    </span>
                                                    <div className="flex items-center">
                                                        <span className="pr-1">
                                                            {handleDetailCardValues(
                                                                key,
                                                                delegatorData[
                                                                key
                                                                ],
                                                                delegatorData,
                                                                true
                                                            ) ?? "N/A"}
                                                        </span>
                                                        {key ===
                                                            "commission_earned" &&
                                                            isDelegator && (
                                                                <div
                                                                    className="relative md:w-[18px] md:h-[18px] text-[#FFF5F566]/35 hover:text-white/80"
                                                                    id={
                                                                        validatorData?.id
                                                                    }
                                                                    onMouseEnter={() =>
                                                                        setIsDelegatorCommissionToolTipOpen(
                                                                            true,
                                                                        )
                                                                    }
                                                                    onMouseLeave={() =>
                                                                        setIsDelegatorCommissionToolTipOpen(
                                                                            false,
                                                                        )
                                                                    }
                                                                >
                                                                    {isDelegatorCommissionToolTipOpen && (
                                                                        <div className="absolute right-[-6px] tooltip_custom bg-white text-[#06080C] rounded-[8px] py-[6px] px-4 w-max">
                                                                            <p className="text-[10px] lg:text-[14px] font-medium break-words">
                                                                                {(totalCommission || totalCommissionDelegatorCard) >
                                                                                    1
                                                                                    ? (totalCommission || totalCommissionDelegatorCard)?.toLocaleString(
                                                                                        "en-US",
                                                                                    )
                                                                                    : (totalCommission || totalCommissionDelegatorCard)}
                                                                            </p>
                                                                        </div>
                                                                    )}
                                                                    <svg
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                        width="22"
                                                                        height="22"
                                                                        viewBox="0 0 22 22"
                                                                        fill="none"
                                                                        style={{ width: "100%", height: "100%" }}
                                                                    >
                                                                        <path
                                                                            d="M10.9997 20.1667C16.0413 20.1667 20.1663 16.0417 20.1663 11C20.1663 5.95837 16.0413 1.83337 10.9997 1.83337C5.95801 1.83337 1.83301 5.95837 1.83301 11C1.83301 16.0417 5.95801 20.1667 10.9997 20.1667Z"
                                                                            stroke="currentColor"
                                                                            strokeWidth="1.5"
                                                                            strokeLinecap="round"
                                                                            strokeLinejoin="round"
                                                                        />
                                                                        <path
                                                                            d="M11 7.33337V11.9167"
                                                                            stroke="currentColor"
                                                                            strokeWidth="1.5"
                                                                            strokeLinecap="round"
                                                                            strokeLinejoin="round"
                                                                        />
                                                                        <path
                                                                            d="M10.9951 14.6666H11.0034"
                                                                            stroke="currentColor"
                                                                            strokeWidth="2"
                                                                            strokeLinecap="round"
                                                                            strokeLinejoin="round"
                                                                        />
                                                                    </svg>
                                                                </div>
                                                            )}
                                                        {key ===
                                                            "rewards_earned" &&
                                                            isDelegator && (
                                                                <div
                                                                    className="relative md:w-[18px] md:h-[18px] text-[#FFF5F566]/35 hover:text-white/80"
                                                                    id={
                                                                        delegatorData?.id
                                                                    }
                                                                    onMouseEnter={() =>
                                                                        handleMouseHover(
                                                                            val,
                                                                        )
                                                                    }
                                                                    onMouseLeave={() =>
                                                                        setIsToolTipOpen(
                                                                            false,
                                                                        )
                                                                    }
                                                                >
                                                                    {isToolTipOpen && (
                                                                        <div className="absolute right-0 tooltip_custom bg-white text-[#06080C] rounded-[8px] py-[6px] px-4 w-max">
                                                                            <p className="text-[10px] lg:text-[14px] font-medium break-words">
                                                                                {formattedRewards}
                                                                            </p>
                                                                        </div>
                                                                    )}
                                                                    <svg
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                        width="22"
                                                                        height="22"
                                                                        viewBox="0 0 22 22"
                                                                        fill="none"
                                                                        style={{ width: "100%", height: "100%" }}
                                                                    >
                                                                        <path
                                                                            d="M10.9997 20.1667C16.0413 20.1667 20.1663 16.0417 20.1663 11C20.1663 5.95837 16.0413 1.83337 10.9997 1.83337C5.95801 1.83337 1.83301 5.95837 1.83301 11C1.83301 16.0417 5.95801 20.1667 10.9997 20.1667Z"
                                                                            stroke="currentColor"
                                                                            strokeWidth="1.5"
                                                                            strokeLinecap="round"
                                                                            strokeLinejoin="round"
                                                                        />
                                                                        <path
                                                                            d="M11 7.33337V11.9167"
                                                                            stroke="currentColor"
                                                                            strokeWidth="1.5"
                                                                            strokeLinecap="round"
                                                                            strokeLinejoin="round"
                                                                        />
                                                                        <path
                                                                            d="M10.9951 14.6666H11.0034"
                                                                            stroke="currentColor"
                                                                            strokeWidth="2"
                                                                            strokeLinecap="round"
                                                                            strokeLinejoin="round"
                                                                        />
                                                                    </svg>
                                                                </div>
                                                            )}
                                                    </div>
                                                </li>
                                            ),
                                        )}
                                    </ul>
                                    {/* Add a <br /> tag if this is not the last item in the map */}
                                    {index !==
                                        Object.entries(
                                            delegatorDetailCardSections,
                                        ).length -
                                        1 && <br />}
                                </React.Fragment>
                            ),
                        )}
                    </>
                )}
            </div>
            <div className="flex items-center gap-4">
                {isDelegator && (
                    <Button
                        className={`bg-green text-[#06080C] py-[19px] md:py-5 px-7 leading-none ${showClaimBtn ? "w-[50%]" : "w-full"
                            } ${tagText === "inactive" ||
                                delegatorData?.amount === 0
                                ? "bg-green/[0.10] text-green/[0.22] !cursor-not-allowed"
                                : ""
                            }`}
                        disabled={
                            tagText === "inactive" ||
                            delegatorData?.amount === 0
                        }
                        onClick={handleDelegate}
                    >
                        Unstake
                    </Button>
                )}

                {showClaimBtn && (
                    <div className="relative w-full flex-1">
                        <Button
                            className={`text-[#06080C] py-[19px] md:py-5 px-7 leading-none w-full ${false
                                ? "bg-green/[0.10] text-green/[0.22] !cursor-not-allowed"
                                : "bg-primaryWhite"
                                }`}
                            disabled={false}
                            onClick={() => {
                                setIsClaimModalOpen(true);
                                setCurrentRewards(rewards?.totalRewards);
                                setSelectedData(
                                    isDelegator ? delegatorData : validatorData,
                                );
                            }}
                        >
                            Claim Reward
                        </Button>
                    </div>
                )}
            </div>
        </div>
    );
}
